import ScribeElementModel from './ScribeElementModel';

class ScribeShapeElementModel extends ScribeElementModel {
  constructor(data) {
    super(data, 'Shape');

    const defaultFillColor = '#C5C5C5'; // one of the default colors

    if (data && data.id) {
      this.shapeType = data.shapeType;
      this.width = data.width;
      this.height = data.height;
      this.radius = data.radius;
      this.rx = data.rx;
      this.ry = data.ry;
      this.fill = data.fill;
      this.opacity = data.opacity;
      this.backgroundType = data.backgroundType;
      this.backgroundColorFrom = data.backgroundColorFrom || data.backgroundColourFrom || defaultFillColor;
      this.backgroundColorTo = data.backgroundColorTo || data.backgroundColourTo || defaultFillColor;
      this.backgroundGradientType = data.backgroundGradientType;
    } else {
      this.shapeType = data.shapeType;
      this.width = 150;
      this.height = 150;
      this.radius = 75;
      this.rx = 100;
      this.ry = 50;
      this.fill = defaultFillColor;
      this.opacity = 1;
      this.backgroundType = 'solid';
      this.backgroundColorFrom = defaultFillColor;
      this.backgroundColorTo = defaultFillColor;
      this.backgroundGradientType = 'vertical';
    }
  }
}

export default ScribeShapeElementModel;
